import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { PermissionsCard } from "./card";
import { setDocumentTitle } from "@/lib/documentTitle";

import { PermissionsTable } from "./table";

export default function Permissions() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Permissions");
  }, []);

  return (
    <Routes>
      <Route index element={<PermissionsTable />} />

      <Route path=":id" element={<PermissionsCard />} />
    </Routes>
  );
}
